import { render } from "./collection-resource-observations.vue?vue&type=template&id=78a912aa"
import script from "./collection-resource-observations.vue?vue&type=script&lang=js"
export * from "./collection-resource-observations.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__